import { useState } from "react";
import { taskService } from "@miplatform/api";
import { HTTP_STATUSES } from "@miplatform/constants";
import { useComponentState } from "@miplatform/hooks";

export function useBuildTemplateViewModel() {
  const [buildTemplates, setBuildTemplates] = useState([]);
  const stateManager = useComponentState();
  const [openAddModal, setOpenAddModal] = useState(false);
  const [selectedItem, setSelectedItem] = useState(null);
  const [openDeleteModal, setOpenDeleteModal] = useState(false);

  const getBuildTemplates = () => {
    stateManager.run(async () => {
      const response = await taskService.buildTemplate.getAll({
        sort: "name asc",
      });
      if (response.status === HTTP_STATUSES.OK) {
        setBuildTemplates(response.data);
      }
    });
  };

  const createBuildTemplate = (data) => {
    return stateManager.run(async () =>
      taskService.buildTemplate.create({
        data,
        toastMessageConfig: {
          success: {
            text: ` ${data.name} was created successfully.`,
          },
        },
      })
    );
  };

  const createMilestone = (data) => {
    return stateManager.run(async () =>
      taskService.milestones.create({
        data,
        toastMessageConfig: {
          success: {
            text: ` ${data.name} was created successfully.`,
          },
        },
      })
    );
  };

  const updateBuildTemplate = (id, data) => {
    return stateManager.run(async () =>
      taskService.buildTemplate.update({
        id,
        data,
        toastMessageConfig: {
          success: {
            text: ` ${data.name} was updated successfully.`,
          },
        },
      })
    );
  };

  const deleteBuildTemplate = (id, data) => {
    return stateManager.run(async () =>
      taskService.buildTemplate.delete({
        id,
        modifiedOn: data.modifiedOn,
        toastMessageConfig: {
          success: {
            text: ` ${data.name} was deleted successfully.`,
          },
        },
      })
    );
  };

  return {
    buildTemplates,
    stateManager,
    openAddModal,
    selectedItem,
    openDeleteModal,
    getBuildTemplates,
    updateBuildTemplate,
    deleteBuildTemplate,
    createBuildTemplate,
    createMilestone,
    setOpenAddModal,
    setSelectedItem,
    setOpenDeleteModal,
  };
}
